var body;

function pause(elem) {
	elem.addClass('bid-ajax-loading');
	elem.data('paused', true);

	if (!body) {
		body = jQuery('body');
	}

	if (typeof body.data('paused-descendent-count') != 'number') {
		body.data('paused-descendent-count', 0);
	}

	body.addClass('bid-descendent-ajax-loading');
	body.data('paused-descendent-count', body.data('paused-descendent-count') + 1);
}

function unpause(elem) {
	elem.removeClass('bid-ajax-loading');
	elem.data('paused', false);

	if (!body) {
		body = jQuery('body');
	}

	if (typeof body.data('paused-descendent-count') != 'number') {
		body.data('paused-descendent-count', 1);
	}

	body.data('paused-descendent-count', body.data('paused-descendent-count') - 1);

	if (body.data('paused-descendent-count') < 1) {
		body.removeClass('bid-descendent-ajax-loading');
	}
}

function is_paused(elem) {
	return elem.data('paused') === true;
}

export {
	pause,
	unpause,
	is_paused
};